module.exports = __webpack_public_path__ + "img/operation.1ff8adf4.png";